/*
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2022-06-29 14:49:41
 * @Description:
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
//全局引入组件
// Vue.component('labelSet', () =>
//     import ('@/components/labelSet/labelSet'));
Vue.component("pageCon", () => import("@/components/page/page"));
Vue.component("searchCon", () => import("@/components/search/search"));
Vue.component("tableInfo", () => import("@/components/table/table"));

export const constantRouterMap = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
  },
  // {
  //     path: '/home',
  //     name: '首页',
  //     component: () =>
  //         import ('@/views/home/welcome')
  // },
  {
    path: "/list",
    name: "列表",
    component: () => import("@/views/layout/list"),
  },
  // ...system
];
// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new Router({
  mode: "hash",
  routes: constantRouterMap,
  scrollBehavior: () => {
    history.pushState(null, null, window.location.href);
  },
});

export default router;
